import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';

// Настройка версии документов для запросов к API
const DOC_VERSION = process.env.REACT_APP_DOC_VERSION;

// Внешний адрес dev-стенда (PROJECT_NOTES §37.7): nginx сам передает /api/ бэкенду :3001, поэтому запросы идут на тот же адрес.
// Абсолютные ссылки иначе ушли бы в боевой tbl.zerdegroup.kz, а localhost и 192.168.1.206 недоступны с телефона и со страницы https
const DEV_HOST = 'dev.zerdegroup.kz';
const DEV_HOST_API_PREFIXES = [
  'https://tbl.zerdegroup.kz/api',
  'http://localhost:3000/api',
  'http://localhost:3001/api',
  'http://192.168.1.206:3001/api'
];

axios.interceptors.request.use((config) => {
  // Автоматическая передача токена сессии для всех авторизованных запросов. Явный x-session-token запроса
  // (смена пароля при входе, до сохранения сессии) не перезаписывается
  const sessionToken = localStorage.getItem('sessionToken');
  if (sessionToken && !(config.headers && config.headers['x-session-token'])) {
    config.headers = config.headers || {};
    config.headers['Authorization'] = `Bearer ${sessionToken}`;
    config.headers['x-session-token'] = sessionToken;
  }

  // Перенаправление всех запросов к API на 192.168.1.206:3001 при локальной разработке
  if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '192.168.1.206')) {
    if (config.url) {
      // Старые (ещё не переведённые на /api/v2) запросы /api/v1 не трогаем - они идут на боевой сервер только для выдачи данных
      if (config.url.includes('/api/v1')) {
        // без перенаправления
      } else if (config.url.startsWith('/api')) {
        config.url = `http://192.168.1.206:3001${config.url}`;
      } else if (config.url.startsWith('https://tbl.zerdegroup.kz/api')) {
        config.url = config.url.replace('https://tbl.zerdegroup.kz/api', 'http://192.168.1.206:3001/api');
      } else if (config.url.startsWith('http://localhost:3000/api')) {
        config.url = config.url.replace('http://localhost:3000/api', 'http://192.168.1.206:3001/api');
      }
    }
  } else if (typeof window !== 'undefined' && window.location.hostname === DEV_HOST) {
    const url = config.url;
    // /api/v1 ведем так же, как при локальной разработке, - не трогаем
    if (url && !url.includes('/api/v1')) {
      const prefix = DEV_HOST_API_PREFIXES.filter(p => url.startsWith(p))[0];
      if (prefix) config.url = `/api${url.slice(prefix.length)}`;
    }
  }

  if (config.url && config.url.includes('/api/v1')) {
    config.headers = config.headers || {};
    config.headers['x-app-version'] = DOC_VERSION;

    if (!config.params) {
      config.params = {};
    }
    config.params.version = DOC_VERSION;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Если сессия истекла или была отозвана на сервере (401), возвращаем пользователя на страницу логина.
    // Блокировка учетной записи или ее точки (403) тоже закрывает сессию на сервере (middlewares/auth.js)
    const code = error.response?.data?.code;
    const sessionClosed = error.response && (error.response.status === 401
      || (error.response.status === 403 && (code === 'USER_DEACTIVATED' || code === 'MASTER_DEACTIVATED')));
    if (sessionClosed) {
      const url = error.config?.url || '';
      const isAuthCheck = url.includes('/api/v2/auth/login') ||
        url.includes('/api/v2/auth/validate-session') ||
        url.includes('/api/v2/biometrics');
      const isMobilePage = window.location.pathname.startsWith('/mobile-');
      if (!isAuthCheck && !isMobilePage && window.location.pathname !== '/') {
        console.warn('[Axios] Сессия истекла или недействительна. Перенаправление на страницу входа.');
        localStorage.removeItem('sessionToken');
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
